import React, { useState } from 'react';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simple password check (you can change this password)
    // For production, this should be handled by backend authentication
    const ADMIN_PASSWORD = 'Meerycat1983';

    setTimeout(() => {
      if (password === ADMIN_PASSWORD) {
        localStorage.setItem('adminAuthenticated', 'true');
        toast.success('Login successful!');
        onLogin();
      } else {
        toast.error('Incorrect password. Please try again.');
      }
      setIsLoading(false);
    }, 500);
  };

  return (
    <div className="min-h-screen bg-page flex items-center justify-center p-4">
      <div className="bg-card p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-medical-red rounded-full mb-4">
            <Lock size={32} className="text-white" />
          </div>
          <h1 className="heading-1 mb-2">Admin Login</h1>
          <p className="body-medium text-text-muted">
            Enter your password to access the dashboard
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group mb-6">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input pr-12"
                placeholder="Enter admin password"
                autoFocus
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-muted hover:text-text-primary"
              >
                {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="btn-primary w-full"
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>

          <div className="mt-6 p-4 bg-section rounded">
            <p className="body-small text-center">
              <strong>Admin Password Updated</strong>
            </p>
            <p className="body-small text-center text-text-muted mt-2">
              Contact Dr Meer if you need password assistance
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
